import { RootStateType } from '@/shared/state/store';
import { TypedUseSelectorHook, useSelector } from 'react-redux';

export const useAppSelector: TypedUseSelectorHook<RootStateType> = useSelector;
